// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q8-KH","colBig":"styles_colBig__1cySK","colSmall":"styles_colSmall__3UE2P"};